import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "text-left"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-2 highlight",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.defineEuropeWarehouseAsDefaultStorage
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Define europe warehouse departure as default storage address, so direct stocks have europe warehouse departure ")], 1)], 1), _c(VDataTable, {
    staticClass: "elevation-1",
    attrs: {
      headers: _vm.headers,
      items: _vm.selectedItems,
      "item-key": "technical_front_id",
      "hide-default-footer": "",
      "disable-pagination": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "top",
      fn: function fn() {
        return [_c(VToolbar, {
          attrs: {
            flat: ""
          }
        }, [_c(VToolbarTitle, [_vm._v("Alternative storage addresses")]), _c(VDivider, {
          staticClass: "mx-4",
          attrs: {
            inset: "",
            vertical: ""
          }
        }), _c(VSpacer), _vm.canManage ? _c(VDialog, {
          attrs: {
            persistent: "",
            "max-width": "950"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref) {
              var on = _ref.on,
                attrs = _ref.attrs;
              return [_c(VBtn, _vm._g(_vm._b({
                staticClass: "mb-2"
              }, "v-btn", attrs, false), on), [_vm._v("New address")])];
            }
          }], null, false, 4141016425),
          model: {
            value: _vm.dialog,
            callback: function callback($$v) {
              _vm.dialog = $$v;
            },
            expression: "dialog"
          }
        }, [_c(VCard, [_c("div", {
          staticClass: "dialog-closer"
        }, [_c(VIcon, {
          staticClass: "far fa-times-circle",
          attrs: {
            disabled: _vm.isSaving
          },
          on: {
            click: _vm.close
          }
        })], 1), _c(VForm, {
          staticClass: "form text-left",
          model: {
            value: _vm.form.valid,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "valid", $$v);
            },
            expression: "form.valid"
          }
        }, [_c(VCardTitle, [_c("span", {
          staticClass: "text-h5"
        }, [_vm._v(_vm._s(_vm.formTitle))])]), _c(VCardText, [_c(VContainer, {
          staticClass: "mt-0 pt-0"
        }, [_c("div", [_c(VTextField, {
          staticClass: "required",
          attrs: {
            required: "",
            label: "Name (country)",
            rules: [_vm.rules.mustNotBeEmpty],
            "hide-details": "auto"
          },
          model: {
            value: _vm.editedItem.name,
            callback: function callback($$v) {
              _vm.$set(_vm.editedItem, "name", $$v);
            },
            expression: "editedItem.name"
          }
        }), _c("addressStorage", {
          ref: "address",
          attrs: {
            baseModel: _vm.editedItem.address,
            listCountries: _vm.countries,
            listStates: _vm.states,
            readOnly: false,
            disabledCountry: _vm.editedItem.isBeingEdited && _vm.editedItem.id > 0,
            typeDisplayError: "rules"
          }
        }), _c(VCheckbox, {
          attrs: {
            label: "Default storage location for producer",
            "hide-details": "auto"
          },
          model: {
            value: _vm.editedItem.isDefaultStorage,
            callback: function callback($$v) {
              _vm.$set(_vm.editedItem, "isDefaultStorage", $$v);
            },
            expression: "editedItem.isDefaultStorage"
          }
        })], 1)])], 1), _c(VCardActions, [_c(VBtn, {
          staticClass: "dfwa-btn --small secondary",
          attrs: {
            rounded: "",
            disabled: _vm.isSaving
          },
          on: {
            click: _vm.close
          }
        }, [_vm._v(" Cancel ")]), _c(VBtn, {
          staticClass: "dfwa-btn --small",
          attrs: {
            rounded: "",
            disabled: !(_vm.form.valid && _vm.$refs.address.valid),
            loading: _vm.isSaving
          },
          on: {
            click: _vm.save
          }
        }, [_vm._v(" Save ")])], 1)], 1)], 1)], 1) : _vm._e(), _c(VDialog, {
          attrs: {
            "max-width": "500px"
          },
          model: {
            value: _vm.dialogDelete,
            callback: function callback($$v) {
              _vm.dialogDelete = $$v;
            },
            expression: "dialogDelete"
          }
        }, [_c(VCard, [_c(VCardTitle, {
          staticClass: "text-h5"
        }, [_vm._v(" Are you sure you want to delete this address ? ")]), _c(VCardActions, [_c(VBtn, {
          staticClass: "dfwa-btn --small secondary",
          attrs: {
            rounded: ""
          },
          on: {
            click: _vm.closeDelete
          }
        }, [_vm._v(" Cancel ")]), _c(VBtn, {
          staticClass: "dfwa-btn --small",
          attrs: {
            rounded: ""
          },
          on: {
            click: _vm.deleteItemConfirm
          }
        }, [_vm._v("OK")])], 1)], 1)], 1)], 1)];
      },
      proxy: true
    }, {
      key: "item.continent",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.listContinents.find(function (x) {
          return x.id == item.address.country.continent_iso_2;
        }).display_name) + " ")];
      }
    }, {
      key: "item.isDefaultStorage",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [item.isDefaultStorage ? _c(VIcon, {
          attrs: {
            small: "",
            color: "green"
          }
        }, [_vm._v("fa-check")]) : _c(VIcon, {
          attrs: {
            small: "",
            color: "red"
          }
        }, [_vm._v("fa-times")])];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_vm.canManage ? [_c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            small: ""
          },
          on: {
            click: function click($event) {
              return _vm.editItem(item);
            }
          }
        }, [_vm._v("mdi-pencil")]), _c(VIcon, {
          attrs: {
            small: ""
          },
          on: {
            click: function click($event) {
              return _vm.deleteItem(item);
            }
          }
        }, [_vm._v("mdi-delete")]), item.id > 0 ? [_c(VBtn, {
          staticClass: "dfwa-btn --small-2 secondary ml-2",
          attrs: {
            rounded: "",
            loading: _vm.isApplyingToStock
          },
          on: {
            click: function click($event) {
              return _vm.applyToStocks(item.address.id_address);
            }
          }
        }, [_vm._v(" Apply to all stocks ")])] : _vm._e()] : _vm._e()];
      }
    }], null, true)
  }), _c("confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };